var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',[_c('div',{staticClass:"d-flex"},[(_vm.title)?_c('Subheader',{staticClass:"mb-4 flex-grow-1",attrs:{"text":_vm.title}}):_vm._e(),_vm._t("titleAction")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }